import K from '../constants/CollectionsConstants';
import slugify from 'slugify';
import axios from 'axios';

export function sectionSubtitle(subtitle) {
    return {
        type: K.SET_SECTION_SUBTITLE,
        payload: subtitle
    };
}

export function sectionLogo(logo) {
    return {
        type: K.SET_SECTION_LOGO,
        payload: logo
    };
}

export function getCollection(id) {
    return dispatch => {
        const endpoint = `${
            process.env.REACT_APP_API_URL
        }/api/collections/${id}`;

        // console.log('Get collection:', endpoint);

        dispatch({
            type: K.GET_COLLECTION,
            payload: []
        });

        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_COLLECTION,
                    payload: response.data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
}

export function getCollections(category, subcategory, path) {
    return dispatch => {
        const filter = {
            where: { category: category, subcategory: subcategory },
            order: 'order ASC'
        };
        const endpoint = `${
            process.env.REACT_APP_API_URL
        }/api/collections?filter=${JSON.stringify(filter)}`;

        // console.log('Get collections:', endpoint);

        dispatch({
            type: K.GET_COLLECTIONS,
            payload: []
        });

        axios
            .get(endpoint)
            .then(function(response) {
                let data = response.data.map(item => {
                    const link = collectionLink(path, item.id, item.title)();

                    return {
                        ...item,
                        link
                    };
                });

                // console.log('data', data);

                dispatch({
                    type: K.GET_COLLECTIONS,
                    payload: data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
}

export function collectionLink(path, id, title) {
    return dispatch => {
        if (path === undefined || id === undefined || title === undefined) {
            return 'invalid-parameters';
        }

        return path + '/' + id + '-' + slugify(title, { lower: true });
    };
}



// WEBPACK FOOTER //
// ./src/actions/CollectionsActions.js